(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-grid-component')) {
    customElements.define(
      'video-grid-component',
      class VideoGridComponent extends HTMLElement {
        connectedCallback() {
          this.autoplay = this.dataset.autoplay === 'true';
          this.videos = this.querySelectorAll('video');
          if (!this.autoplay || this.videos.length === 0) return;

          this.mediaQuery = window.matchMedia('(max-width: 749px)');
          this.observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                const video = entry.target;
                if (entry.isIntersecting && this.isVisible(video)) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                }
              }
            },
            { rootMargin: '80px 0px', threshold: 0.2 }
          );

          this.videos.forEach((video) => {
            video.muted = true;
            video.setAttribute('playsinline', '');
            this.observer.observe(video);
          });

          this.onBreakpointChange = () => {
            this.videos.forEach((video) => {
              if (this.isVisible(video)) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          };

          this.mediaQuery.addEventListener('change', this.onBreakpointChange);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.mediaQuery?.removeEventListener('change', this.onBreakpointChange);
        }

        isVisible(video) {
          return video.offsetWidth > 0 && video.offsetHeight > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
